
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useLanguage } from '@/contexts/LanguageContext';

interface TeamCostDisplayProps {
  cost: number | null;
  tooltipText: string;
  displayLabel: string;
  borderClass?: string;
  textClass: string;
  onClick?: () => void;
  isCurrency?: boolean;
}

export const TeamCostDisplay: React.FC<TeamCostDisplayProps> = ({
  cost,
  tooltipText,
  displayLabel,
  borderClass = "border-primary",
  textClass,
  onClick,
  isCurrency = true
}) => {
  const { t } = useLanguage();
  
  if (cost === null) return null;
  
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant="outline" 
            className={`${borderClass} ${textClass} border-2 bg-background/50 cursor-pointer hover:opacity-90 min-h-[2.25rem] w-full max-w-full px-3 rounded-md text-center flex flex-col items-center justify-center py-1 whitespace-normal break-words leading-tight overflow-hidden`}
            onClick={onClick}
          >
            <span className="text-xs font-medium">{displayLabel}</span>
            <span className="text-xs">
              {typeof cost === 'number' ? 
                (cost % 1 === 0 ? cost : cost.toFixed(2)) : 
                cost}
              {typeof cost === 'number' && isCurrency ? '€' : ''}
            </span>
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="top" align="center" className="bg-white border shadow-lg p-2">
          <p>{t(tooltipText) || tooltipText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

